import { dom } from '@assets/js/utilities/dom.js'

const $sectionAboutProducts = dom('.section-about-products')

$sectionAboutProducts.on('click', '.select-variant-btn', (event, self) => {
    const $wrapper = self.parent()
    const $modal = $wrapper.find('.variant-modal-selector')

    if ($modal.hasClass('active')) {
        $modal.removeClass('active')
        return
    }

    $modal.addClass('active')
})

$sectionAboutProducts.on('click', '.close-modal', (event, self) => {
    const $modal = self.closest('.variant-modal-selector')
    $modal.removeClass('active')
})

$sectionAboutProducts.on('click', '.variant-item', (event, self) => {
    const url = self.data('link')
    window.location.href = url
})
